import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SurViewReturnsModel } from "@tSurya/Services/ViewReturnListService";
import { ViewReturnDataState } from "@tSurya/Store/Data/SurViewReturnDataState";
import { Draft } from "immer";

const initialState: ViewReturnDataState = {
    isLoading: false,
    viewdata: [],
    searchparameter: [],
    pagination: null,
};
const reducer = {
    "Custom/ViewReturnData/BeginLoadViewReturn": (draft: Draft<ViewReturnDataState>) => {
        draft.isLoading = true;
    },
    "Custom/ViewReturnStore/CompletedLoadViewReturnStore": (
        draft: Draft<ViewReturnDataState>,
        action: { searchparameter: SurViewReturnsModel },
    ) => {
        draft.searchparameter = action.searchparameter;
        draft.isLoading = true;
    },
    "Custom/ViewReturn/CompletedLoadViewReturn": (
        draft: Draft<ViewReturnDataState>,
        action: { result: SurViewReturnsModel },
    ) => {
        draft.viewdata = action.result;
        draft.pagination = action.result.pagination;
        draft.isLoading = false;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
